import { render, staticRenderFns } from "./TermsVideo.vue?vue&type=template&id=b0275132&scoped=true"
var script = {}
import style0 from "./TermsVideo.vue?vue&type=style&index=0&id=b0275132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0275132",
  null
  
)

export default component.exports